// utils/auth.ts
import secureStorage from "./secureStorage";

export function getAuthToken() {
  const token = secureStorage.getItem("accessToken");
  return token || null;
}

export function getCurrentUserId() {
  const userData = secureStorage.getJSON("user");
  if (!userData) return null;
  return userData.id || null;
}
